import { render, staticRenderFns } from "./NotificationsSettingsFormProjects.vue?vue&type=template&id=4afbb280"
import script from "./NotificationsSettingsFormProjects.vue?vue&type=script&lang=js"
export * from "./NotificationsSettingsFormProjects.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports